/* eslint-disable max-len */
import { SortOrder, TableColumn, TableStyles } from 'react-data-table-component';
import { PaginationChangePage, PaginationChangeRowsPerPage } from 'react-data-table-component/dist/DataTable/types';

import { MessageCoreFragment } from '@api/operations/fragments/types/MessageCoreFragment';
import {
  AddClinicalNoteToPatient_addClinicalNoteToPatient_ClinicalNotes
} from '@api/operations/mutations/types/AddClinicalNoteToPatient';
import {
  AddPatientMedication_addPatientMedication_MedicationUsages
} from '@api/operations/mutations/types/AddPatientMedication';
import { CreateAppointment_createAppointment_Appointments } from '@api/operations/mutations/types/CreateAppointment';
import {
  CreateConditionsAssessment_createConditionsAssessment_ClinicalImpressions
} from '@api/operations/mutations/types/CreateConditionsAssessment';
import {
  CreateMedicalCondition_createMedicalCondition_Conditions
} from '@api/operations/mutations/types/CreateMedicalCondition';
import { CreatePaymentProfile_createPaymentProfile } from '@api/operations/mutations/types/CreatePaymentProfile';
import {
  CreateQuestionnaireForm_createQuestionnaireForm_Questionnaires
} from '@api/operations/mutations/types/CreateQuestionnaireForm';
import {
  CreateQuestionnaireItems_createQuestionnaireItems_QuestionnaireItems
} from '@api/operations/mutations/types/CreateQuestionnaireItems';
import {
  CreateQuestionnaireResponse_createQuestionnaireResponse_QuestionnaireResponses
} from '@api/operations/mutations/types/CreateQuestionnaireResponse';
import { CreateTask_createTask_Tasks } from '@api/operations/mutations/types/CreateTask';
import { CreateTreatmentPlan_createTreatmentPlan_CarePlans } from '@api/operations/mutations/types/CreateTreatmentPlan';
import {
  ManageUserDependents_manageUserDependents_dependents_Patients
} from '@api/operations/mutations/types/ManageUserDependents';
import {
  RescheduleAppointment_rescheduleAppointment_Appointments
} from '@api/operations/mutations/types/RescheduleAppointment';
import {
  UpdateMedicalCondition_updateMedicalCondition_Conditions
} from '@api/operations/mutations/types/UpdateMedicalCondition';
import {
  UpdatePaymentProfile_updatePaymentProfile_PaymentProfiles
} from '@api/operations/mutations/types/UpdatePaymentProfile';
import {
  UpdateQuestionnaireResponse_updateQuestionnaireResponse_QuestionnaireResponses
} from '@api/operations/mutations/types/UpdateQuestionnaireResponse';
import { UpdateTask_updateTask_Tasks } from '@api/operations/mutations/types/UpdateTask';
import { UpdateTaskStep_updateTaskStep_TaskSteps } from '@api/operations/mutations/types/UpdateTaskStep';
import { Appointment_getAppointment_Appointments } from '@api/operations/queries/types/Appointment';
import {
  ExploreDirectoryFiles_exploreDirectoryFiles_paths_files
} from '@api/operations/queries/types/ExploreDirectoryFiles';
import { GetAllCarePlans_getAllCarePlans_CarePlans } from '@api/operations/queries/types/GetAllCarePlans';
import {
  GetAllClinicalNotes_getAllClinicalNotes_ClinicalNotes
} from '@api/operations/queries/types/GetAllClinicalNotes';
import {
  GetAllCollectionDays_getAllCollectionDays_CollectionDays
} from '@api/operations/queries/types/GetAllCollectionDays';
import {
  GetAllConditionAssessments_getAllConditionAssessments_ClinicalImpressions
} from '@api/operations/queries/types/GetAllConditionAssessments';
import { GetAllCynergyUsers_getAllCynergyUsers_CynergyUsers } from '@api/operations/queries/types/GetAllCynergyUsers';
import {
  GetAllDetailedMedicationUsages_getAllDetailedMedicationUsages_MedicationUsages
} from '@api/operations/queries/types/GetAllDetailedMedicationUsages';
import { GetAllEncounters_getAllEncounters_Encounters } from '@api/operations/queries/types/GetAllEncounters';
import {
  GetAllLocationServices_getAllLocationServices_HealthcareLocationServices
} from '@api/operations/queries/types/GetAllLocationServices';
import {
  GetAllQuestionnaireItems_getAllQuestionnaireItems_QuestionnaireItems
} from '@api/operations/queries/types/GetAllQuestionnaireItems';
import {
  GetAllQuestionnaireResponses_getAllQuestionnaireResponses_QuestionnaireResponses
} from '@api/operations/queries/types/GetAllQuestionnaireResponses';
import {
  GetAllQuestionnaires_getAllQuestionnaires_Questionnaires
} from '@api/operations/queries/types/GetAllQuestionnaires';
import {
  GetAllResourceIdentifiers_getAllResourceIdentifiers_Identifiers
} from '@api/operations/queries/types/GetAllResourceIdentifiers';
import {
  GetAllResourceReferences_getAllResourceReferences_References
} from '@api/operations/queries/types/GetAllResourceReferences';
import { GetAllTasks_getAllTasks_Tasks } from '@api/operations/queries/types/GetAllTasks';
import { GetCarePlan_getCarePlan_CarePlans } from '@api/operations/queries/types/GetCarePlan';
import { GetCareTeam_getCareTeam_CareTeams } from '@api/operations/queries/types/GetCareTeam';
import {
  GetDetailedMedicationUsage_getDetailedMedicationUsage_MedicationUsages
} from '@api/operations/queries/types/GetDetailedMedicationUsage';
import {
  GetHealthcareLocationService_getLocationService_HealthcareLocationServices
} from '@api/operations/queries/types/GetHealthcareLocationService';
import {
  GetLocationPatient_getLocationPatient_LocationPatients
} from '@api/operations/queries/types/GetLocationPatient';
import {
  GetLocationServicesByRadius_getLocationServicesByRadius_HealthcareLocationServices
} from '@api/operations/queries/types/GetLocationServicesByRadius';
import { GetOrganization_getOneOrganization_Organizations } from '@api/operations/queries/types/GetOrganization';
import {
  GetPaginatedCarePlans_getPaginatedCarePlans_rows_CarePlans
} from '@api/operations/queries/types/GetPaginatedCarePlans';
import {
  GetPaginatedConditionAssessments_getPaginatedConditionAssessments_rows_ClinicalImpressions
} from '@api/operations/queries/types/GetPaginatedConditionAssessments';
import {
  GetPaginatedLocationPatients_getPaginatedLocationPatients
} from '@api/operations/queries/types/GetPaginatedLocationPatients';
import {
  GetPaginatedQuestionnaireResponses_getPaginatedQuestionnaireResponses_rows_QuestionnaireResponses
} from '@api/operations/queries/types/GetPaginatedQuestionnaireResponses';
import {
  GetPaginatedQuestionnaires_getPaginatedQuestionnaires_rows_Questionnaires
} from '@api/operations/queries/types/GetPaginatedQuestionnaires';
import { GetPaginatedTasks_getPaginatedTasks_rows_Tasks } from '@api/operations/queries/types/GetPaginatedTasks';
import {
  GetPaginatedWellnessPatientTests_getPaginatedWellnessPatientTests_rows_PatientTest
} from '@api/operations/queries/types/GetPaginatedWellnessPatientTests';
import {
  GetPaginatedWellnessPatientTestSamples_getPaginatedWellnessPatientTestSamples_organismCounts,
  GetPaginatedWellnessPatientTestSamples_getPaginatedWellnessPatientTestSamples_rows_PatientTestSample
} from '@api/operations/queries/types/GetPaginatedWellnessPatientTestSamples';
import {
  GetPaginatedWellnessTestSamplesByFacility_getPaginatedWellnessTestSamplesByFacility_organismCounts,
  GetPaginatedWellnessTestSamplesByFacility_getPaginatedWellnessTestSamplesByFacility_rows_PatientTestSample
} from '@api/operations/queries/types/GetPaginatedWellnessTestSamplesByFacility';
import {
  GetPatient_getPatient_Patients,
  GetPatient_getPatient_Patients_dependents
} from '@api/operations/queries/types/GetPatient';
import {
  GetPatientConditions_getPatientCondition_Conditions
} from '@api/operations/queries/types/GetPatientConditions';
import { GetPatientDemographics_getPatient_Patients } from '@api/operations/queries/types/GetPatientDemographics';
import { GetQuestionnaire_getQuestionnaire_Questionnaires } from '@api/operations/queries/types/GetQuestionnaire';
import {
  GetQuestionnaireResponse_getQuestionnaireResponse_QuestionnaireResponses
} from '@api/operations/queries/types/GetQuestionnaireResponse';
import {
  GetQuestionnaireResponseStatistics_getAllQuestionnaireResponses_QuestionnaireResponses
} from '@api/operations/queries/types/GetQuestionnaireResponseStatistics';
import {
  GetResourceIdentifier_getResourceIdentifier_Identifiers
} from '@api/operations/queries/types/GetResourceIdentifier';
import {
  GetResourceReference_getResourceReference_References
} from '@api/operations/queries/types/GetResourceReference';
import { GetTask_getTask_Tasks } from '@api/operations/queries/types/GetTask';
import { GetUserAccount_getUserAccount_Users } from '@api/operations/queries/types/GetUserAccount';
import { PatientOrders_getAllPatientOrders_PatientOrders } from '@api/operations/queries/types/PatientOrders';
import { PaymentProfiles_getAllPaymentProfiles_PaymentProfiles } from '@api/operations/queries/types/PaymentProfiles';
import { UserCart_getUserCart } from '@api/operations/queries/types/UserCart';
import { UserWishList_getUserWishlist } from '@api/operations/queries/types/UserWishList';
import { GetPaginatedTasksQuery } from '@src/api/gql/graphql';
import { TableColumnType } from '@src/app/modules/components/tables/types';
import { STORAGE_KEYS } from '@src/setup/dictionary';
import { CategoryTypes } from '@store/types/serviceTestTypes';

export type MapKeys<T> = T extends Map<infer K, any> ? K : never;

// eslint-disable-next-line @typescript-eslint/ban-types
export type Primitive = string | Function | number | boolean | symbol | undefined | unknown | null;

export type ComponentProps<T> = T extends | React.ComponentType<infer P> | React.Component<infer P>
  ? JSX.LibraryManagedAttributes<T, P>
  : never;

// Returns a new type that injects one type into the other.
export type InjectType<T, U> = Omit<T, keyof U> & U;

export type ValuesUnion<TEnum extends string | number> = `${TEnum}`;

export type OneOrMany<T> = T | T[];
/**
 * Returns a union type from an array type.
 *
 * Given an array type `T` containing strings, this type returns
 * a union type that includes each string in the array.
 *
 * @example
 * type Resources = ['admin', 'user'];
 * type ResourceKeys = KeysOf<ResourceKeys>; // 'admin' | 'user'
 *
 * @typeparam T - An array type containing string elements.
 * @returns A union type of all string elements in the array.
 */
export type KeysOf<T extends string[] | number[]> = T[number];

export type RequireOnlyOne<T, Keys extends keyof T = keyof T> = Pick<T, Exclude<keyof T, Keys>> & {
  [K in Keys]-?: Required<Pick<T, K>> & Partial<Record<Exclude<Keys, K>, null>>;
}[Keys];

export type StorageKey = {
  [K in keyof typeof STORAGE_KEYS]: (typeof STORAGE_KEYS)[K];
}[keyof typeof STORAGE_KEYS];

export type RequiredProperties<T, P extends keyof T> = Omit<T, P> & Required<Pick<T, P>>;

// Constructs a type consisting of all properties of "Type" non-optional
export type Concrete<Type> = {
  [Property in keyof Type]-?: Type[Property];
};

export type ReplaceKeyInType<T, K extends string, R> =
  Omit<T, K> & R;

export type PromiseFunction<T> = (...args: any[]) => Promise<T>;

export type Callback<TArgs, TResult = any> = (...args: TArgs[]) => TResult;

export type AnyFunction = (...args: any[]) => any;

export type AnyObject<T = any> = { [key: string]: T };

export type Predicate<T> = (...item: T[]) => boolean;

export type Writeable<T> = { -readonly [P in keyof T]: T[P] };

export type EmptyObject = Record<string, never>;

export type Maybe<T> = T | undefined | null;

export type RecursivePartial<T> = {
  [P in keyof T]?: RecursivePartial<T[P]>;
};

export type MapFunc<T = any, R = any> = (
  val: T,
  index?: number,
  arr?: T[]
) => R;

export type Direction = 'rtl' | 'ltr';

export type PageView = 'grid' | 'list';

export type IsAny<T> = unknown extends T ? ([keyof T] extends [never] ? false : true) : false;

// type ExcludeArrayKeys<T> = T extends ArrayLike<any> ? Exclude<keyof T, keyof any[]> : keyof T;

type PathImpl<T, Key extends keyof T> = Key extends string
  ? IsAny<T[Key]> extends true
    ? never
    : T[Key] extends Record<string, any>
      ?
      | `${Key}.${PathImpl<T[Key], Exclude<keyof T[Key], keyof any[]>> &
      string}`
      | `${Key}.${Exclude<keyof T[Key], keyof any[]> & string}`
      : never
  : never;

type PathImpl2<T> = PathImpl<T, keyof T> | keyof T;

export type Path<T> = keyof T extends string
  ? PathImpl2<T> extends infer P
    ? P extends string | keyof T
      ? P
      : keyof T
    : keyof T
  : never;

export type Choose<
  T extends Record<string | number, any>,
  K extends Path<T>
> = K extends `${infer U}.${infer Rest}`
  ? Rest extends Path<T[U]>
    ? Choose<T[U], Rest>
    : never
  : T[K];
// type PathKey<T, Key extends keyof T> = Key extends string
//   ? IsAny<T[Key]> extends true
//     ? never
//     : T[Key] extends Record<string, any>
//       ?
//       | `${Key}.${PathKey<T[Key], ExcludeArrayKeys<T[Key]>> & string}`
//       | `${Key}.${ExcludeArrayKeys<T[Key]> & string}`
//       : never
//   : never;
//
// type PathKeys<T> = PathKey<T, keyof T> | keyof T;
//
// export type Path<T> = keyof T extends string
//   ? PathKeys<T> extends infer P
//     ? P extends string | keyof T
//       ? P
//       : keyof T
//     : keyof T
//   : never;

export enum MedicationFormCodes {
  PHARMACEUTICAL_DOSE = 'Pharmaceutical Dose',
  TABLET = 'Tablet',
  CHEWABLE_TABLET = 'Chewable Tablet',
  OROMUCOSAL_SOLUTION = 'Oromucosal Solution',
  INJECTABLE = 'Injectable',
  INJECTABLE_SOLUTION = 'Injectable Solution',
  INJECTABLE_SUSPENSION = 'Injectable Suspension',
  INJECTABLE_EMULSION = 'Injectable Emulsion',
  INJECTABLE_POWDER = 'Injectable Powder',
  ORAL_TABLET = 'Oral Tablet',
  ORAL_SUSPENSION = 'Oral Suspension',
  ORAL_DROPS = 'Oral Drops',
  ORAL_DROPS_SOLUTION = 'Oral Drops Solution',
  ORAL_DROPS_SUSPENSION = 'Oral Drops Suspension',
  ORAL_DROPS_EMULSION = 'Oral Drops Emulsion'
}

export enum AdministrationMethods {
  ADMINISTER = 'Administer',
  APPLY = 'Apply',
  CHEW = 'Chew',
  INSERT = 'Insert',
  INSTILL = 'Instill',
  SWALLOW = 'Swallow',
  SPRAY = 'Spray',
  INHALE = 'Inhale',
  INJECT = 'Inject',
  SUCK = 'Suck',
  INFUSE = 'Infuse',
  RINSE = 'Rinse',
  GARGLE = 'Gargle',
  RINSE_OR_WASH = 'Rinse-or-wash',
  ORODISPERSE = 'Orodisperse',
  IMPLANT = 'Implant',
  INSUFFLATE = 'Insufflate',
  BATHE = 'Bathe'
}

export type BaseTableProps<T> = {
  columns: Array<TableColumn<T>>
  data: unknown[]
  customStyles?: TableStyles
  keyField?: string
  handlePageChange?: (selectedPage: number) => void
  handlePerPageSize?: (value: number, currentPage?: number) => void
  onSearch?: (searchKey: string) => void
  onSort?: (
    selectedColumn: TableColumnType<T>,
    sortDirection: SortOrder | SortDirection
  ) => void
  searchBarTyping?: boolean
  paginationProps?: Partial<{
    pagination: boolean
    paginationServer?: boolean
    paginationTotalRows: number
    paginationPerPage: number
    paginationDefaultPage: number
    paginationResetDefaultPage: boolean
    rowsPerPage: number
    rowCount: number
    currentPage: number
    onChangePage: PaginationChangePage
    onChangeRowsPerPage: PaginationChangeRowsPerPage
  }>
};

export type IRoles = 'Admin' | 'Patient' | 'Staff' | 'Organization' | 'User';

export type SortDirection = 'ASC' | 'DESC';

export enum SortByOrder {
  ASC = 1,
  DESC = -1,
}

export type ServerPagination = {
  page: number
  size: number
  totalPages?: number
  currentPage?: number
};

export enum UserRoles {
  ADMIN = 'Admin',
  ORGANIZATION = 'Organization',
  STAFF = 'Staff',
  PATIENT = 'Patient',
  PUBLIC = 'Public',
  PRACTITIONER = 'Practitioner',
  GUEST = 'Guest',
}

export type IUserTypes = 'admin' | 'patient' | 'staff' | 'organization';

export type UseLocationType<T> = {
  pathname: string,
  search: string
  hash: string
  state: T
  key: string
};

export interface TaskAlertVar {
  shown: boolean;
  ignored: boolean;
}

export interface ScheduleAlertVar {
  count: number;
}

export type UserAlertsVar = {
  taskAlert: TaskAlertVar
  scheduleAlerts: ScheduleAlertVar
};

export type GetPatientDemographicsType = {
  getPatient: GetPatientDemographics_getPatient_Patients
};

/* eslint-disable max-len */
export type HealthcareLocationServicesType = GetLocationServicesByRadius_getLocationServicesByRadius_HealthcareLocationServices;

export type GetAllLocationServicesType = {
  getAllLocationServices: GetAllLocationServices_getAllLocationServices_HealthcareLocationServices[];
};

export type GetLocationServiceType = {
  getLocationService: GetHealthcareLocationService_getLocationService_HealthcareLocationServices
};

export type GetPaginatedLocationPatientsType = {
  getPaginatedLocationPatients: GetPaginatedLocationPatients_getPaginatedLocationPatients
};

export type GetLocationPatientType = {
  getLocationPatient: GetLocationPatient_getLocationPatient_LocationPatients
};

export type CollectionDaysType = GetAllCollectionDays_getAllCollectionDays_CollectionDays;

export type GetAllCollectionDaysType = {
  getAllCollectionDays: GetAllCollectionDays_getAllCollectionDays_CollectionDays[]
};

export type PaymentProfilesDataType = PaymentProfiles_getAllPaymentProfiles_PaymentProfiles;

export type GetAllPaymentProfilesType = {
  getAllPaymentProfiles: PaymentProfiles_getAllPaymentProfiles_PaymentProfiles[]
};

export type CreatePaymentProfileType = {
  createPaymentProfile: CreatePaymentProfile_createPaymentProfile;
};

export type UpdatePaymentProfileType = {
  updatePaymentProfile: UpdatePaymentProfile_updatePaymentProfile_PaymentProfiles
};

export type CreateAppointmentType = {
  createAppointment: CreateAppointment_createAppointment_Appointments[];
};

export type PatientOrdersType = PatientOrders_getAllPatientOrders_PatientOrders;

export type GetAllPatientOrdersType = {
  getAllPatientOrders: PatientOrders_getAllPatientOrders_PatientOrders[]
};

export type GetAllCynergyUsersType = {
  getAllCynergyUsers: GetAllCynergyUsers_getAllCynergyUsers_CynergyUsers[]
};

export type GetUserAccountType = {
  getUserAccount: GetUserAccount_getUserAccount_Users;
};

export type GetPatientAccountType = {
  getPatient: GetPatient_getPatient_Patients
};

export type GetOrganizationType = {
  getOneOrganization: GetOrganization_getOneOrganization_Organizations
};

export type GetAllEncountersType = {
  getAllEncounters: GetAllEncounters_getAllEncounters_Encounters[]
};

export type ManageUserDependentsType = {
  manageUserDependents: {
    __typename: 'UpdateDependentsResponse';
    dependents: ManageUserDependents_manageUserDependents_dependents_Patients[]
  }
};

export type GetDetailedMedicationUsageType = {
  getDetailedMedicationUsage: GetDetailedMedicationUsage_getDetailedMedicationUsage_MedicationUsages
};

export type GetAllDetailedMedicationUsagesType = {
  getAllDetailedMedicationUsages: GetAllDetailedMedicationUsages_getAllDetailedMedicationUsages_MedicationUsages[]
};

export type CreateTreatmentPlanType = {
  createTreatmentPlan: CreateTreatmentPlan_createTreatmentPlan_CarePlans
};

export type CreateConditionAssessmentType = {
  createConditionsAssessment: CreateConditionsAssessment_createConditionsAssessment_ClinicalImpressions[]
};

export type GetAllConditionAssessmentsType = {
  getAllConditionAssessments: GetAllConditionAssessments_getAllConditionAssessments_ClinicalImpressions[]
};

export type AddPatientMedicationType = {
  addPatientMedication: AddPatientMedication_addPatientMedication_MedicationUsages
};

export type CreateMedicalConditionType = {
  createMedicalCondition: CreateMedicalCondition_createMedicalCondition_Conditions
};

export type UpdateMedicalConditionType = {
  updateMedicalCondition: UpdateMedicalCondition_updateMedicalCondition_Conditions
};

export type CreateClinicalNoteType = {
  addClinicalNoteToPatient: AddClinicalNoteToPatient_addClinicalNoteToPatient_ClinicalNotes
};

export type GetPatientConditionType = {
  getPatientCondition: GetPatientConditions_getPatientCondition_Conditions
};

export type GetAllClinicalNotesType = {
  getAllClinicalNotes: GetAllClinicalNotes_getAllClinicalNotes_ClinicalNotes[]
};

export type GetCarePlanType = {
  getCarePlan: GetCarePlan_getCarePlan_CarePlans
};

export type GetAllCarePlansType = {
  getAllCarePlans: GetAllCarePlans_getAllCarePlans_CarePlans[]
};

export type GetPaginatedCarePlansType = {
  getPaginatedCarePlans: {
    __typename: 'ClinicalCarePaginatedResponse';
    count: number;
    currentPage: number;
    totalPages: number;
    rows: GetPaginatedCarePlans_getPaginatedCarePlans_rows_CarePlans[]
  }
};

export type GetCareTeamType = {
  getCareTeam: GetCareTeam_getCareTeam_CareTeams
};

export type GetPaginatedConditionAssessmentsType = {
  getPaginatedConditionAssessments: {
    __typename: 'ClinicalCarePaginatedResponse';
    count: number;
    currentPage: number;
    totalPages: number;
    rows: GetPaginatedConditionAssessments_getPaginatedConditionAssessments_rows_ClinicalImpressions[]
  }
};

export type DependentsType = GetPatient_getPatient_Patients_dependents;

export type UserMessageType = MessageCoreFragment;

export type RescheduleAppointmentType = {
  rescheduleAppointment: RescheduleAppointment_rescheduleAppointment_Appointments
};

export type GetAppointmentType = {
  getAppointment: Appointment_getAppointment_Appointments
};

export type UserFile = ExploreDirectoryFiles_exploreDirectoryFiles_paths_files;

export type GetPaginatedWellnessPatientTestsType = {
  getPaginatedWellnessPatientTests: {
    __typename: 'WellnessPaginatedResponse';
    count: number;
    currentPage: number;
    totalPages: number;
    rows: GetPaginatedWellnessPatientTests_getPaginatedWellnessPatientTests_rows_PatientTest[]
  }
};

export type GetPaginatedWellnessPatientTestSamplesType = {
  getPaginatedWellnessPatientTestSamples: {
    __typename: 'WellnessPatientTestSampleData';
    count: number;
    currentPage: number;
    totalPages: number;
    organismCounts: GetPaginatedWellnessPatientTestSamples_getPaginatedWellnessPatientTestSamples_organismCounts[] | null;
    rows: GetPaginatedWellnessPatientTestSamples_getPaginatedWellnessPatientTestSamples_rows_PatientTestSample[]
  }
};
export type GetPaginatedWellnessTestSamplesByFacilityType = {
  getPaginatedWellnessTestSamplesByFacility: {
    __typename: 'WellnessPatientTestSampleData';
    count: number;
    currentPage: number;
    totalPages: number;
    organismCounts: GetPaginatedWellnessTestSamplesByFacility_getPaginatedWellnessTestSamplesByFacility_organismCounts[] | null;
    rows: GetPaginatedWellnessTestSamplesByFacility_getPaginatedWellnessTestSamplesByFacility_rows_PatientTestSample[]
  }
};

export type GetPaginatedTasksType = {
  getPaginatedTasks: {
    __typename: 'TaskPaginatedResponse',
    count: number
    currentPage: number
    totalPages: number
    rows: GetPaginatedTasks_getPaginatedTasks_rows_Tasks[]
  }
};

export type UserTaskType = GetPaginatedTasksQuery['getPaginatedTasks']['rows'][0];

export type GetAllTasksType = {
  getAllTasks: GetAllTasks_getAllTasks_Tasks[]
};

export type GetTaskType = {
  getTask: GetTask_getTask_Tasks
};

export type CreateTaskType = {
  createTask: CreateTask_createTask_Tasks
};

export type UpdateTaskType = {
  updateTask: UpdateTask_updateTask_Tasks
};

export type UpdateTaskStepType = {
  updateTaskStep: UpdateTaskStep_updateTaskStep_TaskSteps
};

export type GetQuestionnaireType = {
  getQuestionnaire: GetQuestionnaire_getQuestionnaire_Questionnaires
};

export type GetQuestionnaireResponseType = {
  getQuestionnaireResponse: GetQuestionnaireResponse_getQuestionnaireResponse_QuestionnaireResponses;
};

export type GetAllQuestionnairesType = {
  getAllQuestionnaires: GetAllQuestionnaires_getAllQuestionnaires_Questionnaires[]
};

export type GetAllQuestionnaireItemsType = {
  getAllQuestionnaireItems: GetAllQuestionnaireItems_getAllQuestionnaireItems_QuestionnaireItems[]
};

export type GetAllQuestionnaireResponsesType = {
  getAllQuestionnaireResponse: GetAllQuestionnaireResponses_getAllQuestionnaireResponses_QuestionnaireResponses[]
};

export type GetQuestionnaireResponseStatisticsType = {
  getAllQuestionnaireResponses: GetQuestionnaireResponseStatistics_getAllQuestionnaireResponses_QuestionnaireResponses[]
};

export type CreateQuestionnaireFormType = {
  createQuestionnaireForm: CreateQuestionnaireForm_createQuestionnaireForm_Questionnaires
};

export type CreateQuestionnaireItemsType = {
  createQuestionnaireItems: CreateQuestionnaireItems_createQuestionnaireItems_QuestionnaireItems[]
};

export type CreateQuestionnaireResponseType = {
  createQuestionnaireResponse: CreateQuestionnaireResponse_createQuestionnaireResponse_QuestionnaireResponses
};

export type UpdateQuestionnaireResponseType = {
  updateQuestionnaireResponse: UpdateQuestionnaireResponse_updateQuestionnaireResponse_QuestionnaireResponses
};

export type GetPaginatedQuestionnairesType = {
  getPaginatedQuestionnaires: {
    __typename: 'FeedbackPaginatedResponse';
    count: number;
    currentPage: number;
    totalPages: number;
    rows: GetPaginatedQuestionnaires_getPaginatedQuestionnaires_rows_Questionnaires[]
  }
};

export type GetPaginatedQuestionnaireResponsesType = {
  getPaginatedQuestionnaireResponses: {
    __typename: 'FeedbackPaginatedResponse';
    count: number;
    currentPage: number;
    totalPages: number;
    rows: GetPaginatedQuestionnaireResponses_getPaginatedQuestionnaireResponses_rows_QuestionnaireResponses[]
  }
};

export type GetResourceReferenceType = {
  getResourceReference: GetResourceReference_getResourceReference_References
};

export type GetAllResourceReferencesType = {
  getAllResourceReferences: GetAllResourceReferences_getAllResourceReferences_References[]
};

export type GetResourceIdentifierType = {
  getResourceIdentifier: GetResourceIdentifier_getResourceIdentifier_Identifiers
};

export type GetAllResourceIdentifiersType = {
  getAllResourceIdentifiers: GetAllResourceIdentifiers_getAllResourceIdentifiers_Identifiers[]
};

export interface ServiceItemProps {
  service_id: string;
  service_image: string;
  imageAlt: string;
  service_name: string;
  service_category: CategoryTypes[];
  service_description: string;
  service_price: number;
  report_turnaround: number | number[];
  delivery_time_string: string;
  rating: number;
  link?: JSX.Element;

}

export interface UserCartProps extends UserCart_getUserCart {
  serviceName: string;
  servicePrice: string;
  timeBlockID: string;
  collectionDate: string;
  collectionTime: string;
  locationName: string;
  locationPhone: string;
  locationAddress: string;
  serviceDescription: string;
  discountRate?: number;
  userRating: number;
}

export type UserWishlistProps = UserWishList_getUserWishlist;
